/* 🤖 this file was generated by svg-to-ts */
export const mgcIconOctagonFilled: {
  name: 'octagon-filled';
  data: string;
} = {
  name: 'octagon-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.655 2.579c-.354.078-.683.22-.999.431-.191.128-.934.846-2.421 2.338C2.911 7.68 2.889 7.706 2.652 8.38l-.112.32v6.6l.112.32c.238.679.251.693 2.643 3.085C7.69 21.1 7.72 21.126 8.389 21.354l.311.106h6.6l.311-.106c.669-.228.699-.254 3.094-2.649 2.392-2.392 2.405-2.406 2.643-3.085l.112-.32V8.7l-.106-.311c-.228-.669-.254-.699-2.649-3.094s-2.425-2.421-3.094-2.649L15.3 2.54l-3.2-.007c-2.558-.006-3.249.003-3.445.046"/></svg>`
};
